import { connect } from 'react-redux';
import { eventFilterSet,requestProposals } from '../modules/tour';

import TourCalendarTab from './TourCalendarTab';

const mapDispatchToProps = {
  eventFilterSet,
  requestProposals
};

const mapStateToProps = state => ({
  filter: state.tours.selectedTour.eventFilter,
  proposals: state.tours.selectedTour.proposals,
});

export default connect(mapStateToProps, mapDispatchToProps)(TourCalendarTab);



// WEBPACK FOOTER //
// src/routes/tours/components/TourCalendarTabContainer.js